import store from 'store'

const el = '[data-content=HoldetsDeltagere]'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((HoldetsDeltagereDOM)=>{
            const teamId = HoldetsDeltagereDOM.dataset.teamid
            const addDeltagerFormUrl = HoldetsDeltagereDOM.dataset.addDeltagerFormUrl
            const donationFormUrl = HoldetsDeltagereDOM.dataset.donationFormUrl
            const lysposeFormUrl = HoldetsDeltagereDOM.dataset.lysposeFormUrl
            
            store.commit('main/set_page_overlay_content_data',{ teamId, addDeltagerFormUrl, donationFormUrl, lysposeFormUrl })
        })
    }
}